<div aria-labelledby="inlcudes-tab" class="tab-pane tab-content fade" id="hotelAmenity" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p>{{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <form>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-8 offset-2">
                            <div class="empty-data green">
                                <p>
                                    your hotel amenity .
                                </p>
                            </div>
                            <div class="mb-3" v-if="!ui.status.canAdd">
                                <a @click.prevent="showAddHotelAmenityButton()" class="btn default-btn" href=""><i class="fas fa-plus"></i> Add new amenity</a
                >
              </div>
            </div>
          </div>

          <div class="form-group row" v-if="ui.status.canAdd">
            <label class="col-sm-2 col-form-label" for="staticEmail">
              Property Amenity</label
            >
            <div class="col-sm-8">
              <div class="form-group">
                <div class="multiselect-input" v-if="item.amenityList">
                  <multiselect
                    :options="item.amenityList"
                    :track-by="'title'"
                    label="title"
                    placeholder="Choose Amenity.."
                    v-model="item.hotelAmenityList.amenity"
                  >
                  </multiselect>
                </div>
              </div>

              <div
                class="row form-group"
                v-for="(experience, index) in addData"
                :key="index"
              >
                <div class="col-sm-8">
                  <label for="">Services</label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword"
                    v-model="experience.title"
                    placeholder="eg free wifi etc"
                  />
                </div>
                <div class="col-sm-3">
                  <div class="includes-action justify-content-start">
                    <button
                      @click="removeField(index , addData)"
                      type="button"
                      class="btn red"
                    >
                      <i class="fas fa-window-close"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <a
                  @click.prevent="addNewService()"
                  class="btn default-btn"
                  href=""
                  ><i class="fas fa-plus"></i> Add More Services</a
                >
              </div>
            </div>
            <div class="col-sm-2">
              <a
                @click.prevent="addHotelAmenity"
                class="btn btn-sm add-btn"
                href="#"
                role="button"
                >{{buttonTextAddHotelAmenity}}
                <spinner
                  :loading="ui.status.postLoading.create"
                  v-if="ui.status.postLoading.create"
                ></spinner>
              </a>
                            </div>
                        </div>
                        <div :key="index" class="form-group row" v-for="(list, index) in item.hotelAmenityList">
                            <div class="col-lg-8 offset-lg-2">
                                <div class="empty-data">
                                    <p v-if="list.length === 0">
                                        No Amenity List
                                    </p>
                                </div>

                                <div class="includes-list-item">
                                    <div class="includes-list hoverable-list readonly" v-if="!list.IsActive">
                                        <label class="readonly"><span v-if="list.amenity"
                      >{{list.amenity.title}}</span
                    ></label
                  >
                  <div class="list-ico">
                    <img :src="list.amenity.image_path" v-if="list.amenity" />
                  </div>
                  <!-- delete modals -->
                </div>

                <div class="includes-list editable" v-if="list.IsActive">
                  <div class="row">
                    <div class="col-lg-10">
                      <div class="form-group">
                        <div class="multiselect-input" v-if="item.amenityList">
                          <multiselect
                            :options="item.amenityList"
                            :track-by="'title'"
                            label="title"
                            placeholder="Choose Amenity.."
                            v-model="list.amenity"
                          >
                          </multiselect>
                        </div>

                        <div
                          class="row form-group"
                          v-if="list.amenity_service"
                          v-for="(service ,index) in list.amenity_service"
                      :key="index">
                          <div class="col-sm-8">
                            <label for="">Services</label>
                                        <input type="text" class="form-control" id="inputPassword" v-model="service.title" placeholder="eg free wifi etc" />
                                    </div>

                                    <div class class="col-sm-3 ">
                                        <div class="includes-action justify-content-start">
                                            <button type="button" @click="removeService(index , service ,list.amenity_service)" class="btn red ">
                                <i class="fas fa-window-close "></i>
                              </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group " v-for="(experience, index) in addData " :key="index ">
                                    <div class="col-sm-8 ">
                                        <label for=" ">Services</label>
                                        <input type="text " class="form-control " id="inputPassword " v-model="experience.title " placeholder="eg free wifi etc " />
                                    </div>
                                    <div class="col-sm-3 ">
                                        <div class="includes-action justify-content-start ">
                                            <button @click="removeField(index , addData) " type="button " class="btn red ">
                                <i class="fas fa-window-close "></i>
                              </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 ">
                                    <a @click.prevent="addNewService() " class="btn default-btn " href=" "><i class="fas fa-plus "></i> Add More Services</a
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2">
                      <div class="includes-action justify-content-start">
                        <button
                          @click.prevent="editHotelAmenity()"
                          class="btn green"
                          type="button"
                          v-if="list.IsActive"
                        >
                          <i class="fas fa-save"></i>
                        </button>
                        <button
                          @click.prevent="cancelHotelAmenity(index, list)"
                          class="btn red"
                          type="button"
                          v-if="list.IsActive"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="includes-action">
                <button
                  @click.prevent="onEditHotelAmenityClick(index, list)"
                  class="btn blue"
                  type="button"
                  v-if="!ui.status.canEdit"
                >
                  <i class="fas fa-pen"></i>
                </button>
                <button
                  @click.prevent="onDeleteHotelAmenityClick(index, list)"
                  class="btn red"
                  type="button"
                >
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="modal-wrap">
        <div
          aria-labelledby="exampleModalLabel"
          class="modal fade show"
          id="deleteSelectedHotelAmenity"
          role="dialog"
          tabindex="-1"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Delete Amenity</h5>
                <button
                  aria-label="Close"
                  class="close"
                  data-dismiss="modal"
                  type="button"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="error-list" v-if="ui.error.modal.delete">
                <ul class="error-msg">
                  <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                    {{ error }}
                  </li>
                </ul>
              </div>
              <div class="modal-body">
                <p>
                  Are you sure you want to delete this ?
                </p>
              </div>

              <div class="modal-footer">
                <button
                  @click.prevent="deleteHotelAmenity()"
                  class="btn default-btn"
                  type="button"
                >
                  Ok
                  <spinner
                    :loading="ui.status.postLoading.delete"
                    v-if="ui.status.postLoading.delete"
                  ></spinner>
                </button>
                <button
                  :disabled="ui.status.postLoading.delete"
                  @click.prevent="hideDeleteModal"
                  aria-label="Close"
                  class="btn default-btn cancel"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>